// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"CopySitePermissionsForm__wrapper__32bBd","submitResult":"CopySitePermissionsForm__submitResult__y-dyU","actionWrapper":"CopySitePermissionsForm__actionWrapper__2ZdqJ","wrapper2faOptions":"CopySitePermissionsForm__wrapper2faOptions__GpW1o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CopySitePermissionsForm/CopySitePermissionsForm.css
// module id = 1874
// module chunks = 0